import {createSelector} from '@reduxjs/toolkit';

import {Markets} from 'models/Market';
import {sortMarkets} from 'utils/marketsSort';

import {AppState} from '../';
import {MarketsState} from './markets.reducer';

const marketsState = (state: AppState): MarketsState => state.markets;

/**
 * Stable reference so consumers of marketsSelector keep their memoization when
 * there are no markets.
 */
const NO_MARKETS: Markets = [];

export const marketsSelector = createSelector(marketsState, state =>
  Array.isArray(state?.markets) ? state.markets : NO_MARKETS
);

export const marketsLastQueryTimeSelector = createSelector(
  marketsState,
  state => state?.lastQueryTime
);

export const marketsFailedSelector = createSelector(
  marketsState,
  state => state?.failed
);

export const marketsLoadingSelector = createSelector(
  marketsState,
  state => state?.loading
);

export const sortedMarketsSelector = createSelector(marketsSelector, markets =>
  markets.slice().sort(sortMarkets)
);
